import { InvitedUserInterface } from "../interface/UserInterface";

export function getDaysLeft(invitation: InvitedUserInterface): number {
  const now = new Date();
  const completionDate = new Date(invitation.meta.feedback_completion_date);

  const timeDiff = completionDate.getTime() - now.getTime();
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

  return Math.max(days, 0);
}

export function calculateDaysRemaining(
  invitation: InvitedUserInterface,
): number {
  const now = new Date();
  const completionDate = new Date(invitation.meta.feedback_completion_date);

  const timeDiff = completionDate.getTime() - now.getTime();

  // Always round UP to the next whole day
  return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
}
